import QualityControlStore from "./QualityControl/QualityControlStore";

const qualityControlStoreList = [
    { name: "qualityControlStore", store: QualityControlStore },
];

export default qualityControlStoreList;
